import { createAction } from '@reduxjs/toolkit';

export const onExpandProductDescriptionToggle = createAction<boolean>(
  'productDescription/onExpandProductDescriptionToggle',
);
